import { salesLeadsTabs } from "containers/Sales/leads/tabs";
import { LeadsIcon } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";

const content = l(() => import("containers/Sales/leads"));

const {
  SALES_DASHBOARD_VIEW,
  PREVIEW_USER,
  POWUR_NECESSITIES,
  ENTERPRISE_SUPPORT,
  ENTERPRISE_ADMIN,
  ENTERPRISE_MANAGER,
} = permissionTypes;

export default {
  key: "leads",
  title: "Leads",
  path: "/leads/:tab?",
  linkTarget: "/leads",
  linkTitle: "Leads",
  linkCategory: "Sales",
  icon: LeadsIcon,
  basePath: "leads",
  requiredParams: ["tab"],
  optionalParams: [],
  tabs: salesLeadsTabs,
  content,
  permission: [
    SALES_DASHBOARD_VIEW,
    PREVIEW_USER,
    POWUR_NECESSITIES,
    ENTERPRISE_SUPPORT,
    ENTERPRISE_ADMIN,
    ENTERPRISE_MANAGER,
  ],
};
